<template>
  <!-- 安全管理 -->
  <a-layout-content>
    <div>
      <a-form-model :model="getparm">
        <a-row>
          <a-col :span="9">
            <a-form-item label="注册代理链结">
              <a-input style="width: 70%" v-model="getparm.Registerurl" />
            </a-form-item>
            <a-form-item label="代理后台链接">
              <a-input style="width: 70%" v-model="getparm.Loginurl" />
            </a-form-item>
            <a-form-item label="在线客服链接">
              <a-input style="width: 70%" v-model="getparm.ServiceLink" />
            </a-form-item>
            <a-form-item label="佣金計算設置">
              <a-row>
                <a-col :span="24">存款返佣：<a-input-number :min="0" :max="100" :formatter="value => `${value}%`"
                    v-model="getparm.DepositPercent" /></a-col>
                <a-col :span="9">电子类投注返佣：<a-input-number :min="0" :max="100" :formatter="value => `${value}%`"
                    v-model="getparm.SlotValidbetPercent" /></a-col>
                <a-col :span="12">真人体育类投注返佣：<a-input-number :min="0" :max="100" :formatter="value => `${value}%`"
                    v-model="getparm.ValidbetPercent" /></a-col>
              </a-row>
              <span style="color: red;">备注：佣金总额=昨日总入款*存款返佣%+电子类有效投注*电子类投注返佣%+真人体育类有效投注*真人体育类投注返佣%</span>
            </a-form-item>
            <a-form-item label="修改人">
              <span>{{ getparm.Modify }}</span>
            </a-form-item>
            <a-form-item label="修改时间">
              <span>{{ getparm.Ldt }}</span>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" style="margin-left: 80%" @click="save()">
                保存
              </a-button>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-tabs default-active-key="1">
              <a-tab-pane key="1">
                <span slot="tab">IP黑名单&nbsp;
                  <a-tooltip title="【针对前端提交做限制】">
                    <a-icon type="info-circle" />
                  </a-tooltip></span></span>
                <span style="color: red">每个IP用段行隔开</span>
                <br />
                <a-textarea v-model="getparm.IPlist" style="width: 400px; height: 400px">
                </a-textarea>
              </a-tab-pane>
              <a-tab-pane key="2" force-render>
                <span slot="tab">代理黑名单&nbsp;
                  <a-tooltip title="【针对前端提交做限制】">
                    <a-icon type="info-circle" />
                  </a-tooltip></span>
                <a-icon type="info-circle" />
                <span style="color: red">每个代理用段行隔开</span>
                <br />
                <a-textarea v-model="getparm.Userlist" style="width: 400px; height: 400px">
                </a-textarea>
              </a-tab-pane>
            </a-tabs>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
  </a-layout-content>
</template>

<script>
  export default {
    data() {
      return {
        getparm: {
          IPlist: "", Userlist: "", Modify: "", Ldt: "", ID: "0", DepositPercent: "0", ValidbetPercent: "0", SlotValidbetPercent: "0", Registerurl: "", Loginurl: "",
          ServiceLink: "",
        },
        selectOption: {
          limitlist: [],
        },
      };
    },
    methods: {
      //查询API
      query() {
        this.axios.post("/agentpromotion/getagentpromotionset", "").then((res) => {
          if (res.data.length != 0) {
            let json = JSON.parse(res.data);
            this.getparm.ID = json.ID;
            this.getparm.DepositPercent = json.DepositPercent;
            this.getparm.ValidbetPercent = json.ValidbetPercent;
            this.getparm.SlotValidbetPercent = json.SlotValidbetPercent;
            this.getparm.Registerurl = json.RegisterUrl;
            this.getparm.Loginurl = json.LoginUrl;
            this.getparm.ServiceLink = json.ServiceLink;
            this.getparm.Modify = json.Modify;
            this.getparm.Ldt = json.Ldt;

            let IPArr = "";
            let UserArr = "";

            json.Blacklist.forEach(function (item) {
              if (item.Type == "1") {
                IPArr += item.Value + "\n";
              }
              else if (item.Type == "2") {
                UserArr += item.Value + "\n";
              }
            });
            this.getparm.IPlist = IPArr.slice(0, IPArr.length - 1);
            this.getparm.Userlist = UserArr.slice(0, UserArr.length - 1);
          }
        });
      },
      //保存IP
      save() {
        let Blacklist = [];
        let IPstr = this.getparm.IPlist;
        let IPArray = IPstr.split(/[\s\n]/);
        let _this = this;
        let goon = true;
        IPArray.forEach(function (value) {
          const v4reg =
            /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
          if (!v4reg.test(value) && value != "") {
            goon = false;
            return _this.$message.error(value + "请输入正确的ip");
          }
          var json = {};
          json["Type"] = 1;
          json["Value"] = value;
          Blacklist.push(json);
        });

        let Userstr = this.getparm.Userlist;
        let UserArray = Userstr.split(/[\s\n]/);

        UserArray.forEach(function (value) {
          if (value.length > 0) {
            var json = {};
            json["Type"] = 2;
            json["Value"] = value;
            Blacklist.push(json);
          }
        })

        let params = {
          ID: this.getparm.ID,
          DepositPercent: this.getparm.DepositPercent,
          ValidbetPercent: this.getparm.ValidbetPercent,
          SlotValidbetPercent: this.getparm.SlotValidbetPercent,
          ServiceLink: this.getparm.ServiceLink,
          RegisterUrl: this.getparm.Registerurl,
          LoginUrl: this.getparm.Loginurl,
          Blacklist: Blacklist,
        };

        if (goon) {
          this.axios
            .post("/agentpromotion/agentpromotionsetsave", params)
            .then((res) => {
              if (res.data) {
                this.$message.success("保存成功!");
                this.query();
              } else {
                this.$message.error(res.error);
              }
            });
        }
      },
    },
    watch: {
      $route(to, from) {
        if (this.$route.params.name === "agentpromotionset") {
          this.query();
        }
      },
    },
    //首次加载
    created() {
      this.query();
    },
  };
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/agentpromotion/agentpromotionset.vue